import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Graphics } from './components/Graphics';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../toast/Toast";

import "./Marker.scss";
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';

export class Marker extends Component {
constructor(props) {
  super(props);

  this.state = {}

  const interactions = (heldObj, target) => {
    //Don't run if this gel not the held object
    if(heldObj.type !== "Marker" || heldObj.id !== this.props.id){
      return null;
    }
    if (target === undefined || target === null) {
      this.props.setGelOnShelf({
        id: this.props.id,
        onShelf: false
      });
      return null;
    }
    if (target.type === "Solution") {
        this.props.setModal({
            type: 'LABEL_TUBES',
            size: 'lg',
          });
        this.props.showModal({display: true});
    
    } else if(target.type === "Shelf") {

        this.props.setGelOnShelf({
          id: this.props.id,
          onShelf: true
        });

        this.props.setGelHeld({
          id: this.props.id,
          held: false
        });

      } 
    else {

        this.props.setGelOnShelf({
          id: this.props.id,
          onShelf: false
        });

        this.props.setGelHeld({
          id: this.props.id,
          held: false
        });
      }
}


  Object.defineProperty(interactions, 'name', {value: ('marker_interactions_'+this.props.id), configurable: true});
  console.log('interactions: ', interactions);
  this.props.pushInteractions([interactions]);
}

componentWillMount() {
  this.props.createMarker({
    props: this.props.defaultProps,
  });
}

makeToast = (type, msg, title) => {
  let color = "";
  if (type === "HINT") {
    color = colors.yellow1;
  } else {
    color = colors.red1;
  }

  toast(<Toast type={type} msg={msg} title={title} />,{
    className: css({
      border: "2px solid "+color,
      borderRadius: "6px",
      marginLeft: "-200px",
      minWidth: "400px",
      paddingLeft: 0
    }),
    progressClassName: css({
      background: color
    }),
    position: "top-center",
    autoClose: 5000,
  });
}

showControls = ()=> {
  this.props.hideAllControls();
  this.props.setGelControlVisibility({id: this.props.id, controlsVisible: true});
}

markerSelected = (e) => {

  if(!this.props.controlsVisible){
      this.showControls()
  }

  this.props.setGelHeld({
    id: this.props.id,
    held: true,
  })

  // this.props.setSolutionHeld({
  //   id: this.props.id,
  //   held: true,
  // });
  this.props.setHeldObject({
    id: this.props.id,
    type: "Marker",
    htmlObj: e.target,
  });

}

openLabelTubesDialog = () => {
  this.props.setModal({
    type: 'LABEL_TUBES',
    size: 'lg',
  });
  this.props.showModal({display: true});
}

setMarkerOpen = () => {
  this.props.setMarkerOpen({
    id: this.props.id,
    open: !this.props.open,
  });
};

markerUnSelected = (e) => {
  this.props.setGelHeld({
    id: this.props.id,
    held: false,
  })
}

showMoveMenu = e => {
  this.props.setMoveMenu({
    type: this.props.type,
    connect: this.props.id
  });
  this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
};

render(){
  return (
      <ul style={{ display:(!this.props.inScene)?'none':null, zIndex: (this.props.controlsVisible)?99:null }}>
         <li
            // onClick={this.setMarkerOpen}
            onClick={this.openLabelTubesDialog}
            onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.markerSelected() } }
            onDragStart={(e) => this.markerSelected(e)}
            onDragEnd={(e) => this.markerUnSelected(e)}
            draggable
            tabIndex={0}
            id={"Marker_"+this.props.id}
            className = {"Marker draggable droptarget"+ this.props.id}
             style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
            <p className="label" aria-hidden="true">{'Timer'}</p>
            <Graphics id={this.props.id}/>
          </li>
      </ul>
    );
  }
}


Marker.propTypes = {
  createMarker: PropTypes.func,
}

Marker.defaultProps = {

}